import { AxiosResponse } from 'axios'
import { IEsGlobalSearchItem } from 'types/eslasticSearch'
import { api } from 'API'
import { IElasticsearchRequest, IElasticsearchResponse, ISeearchHistory } from 'interfaces/search'
import { GlobalSearchDto } from 'stores/searchStore'
import { IFilter } from '../../types/common/query'

export async function searchItems<T>(searchInput: IElasticsearchRequest): Promise<IElasticsearchResponse<T>> {
  const searchResults: AxiosResponse = await api.post(`/search`, searchInput)
  return searchResults.data
}

export async function searchGlobal(
  filter: IFilter<GlobalSearchDto>
): Promise<IElasticsearchResponse<IEsGlobalSearchItem>> {
  const response: AxiosResponse = await api.get(`/search/global?filter=${JSON.stringify(filter)}`)
  return response.data
}

export async function addSearchHistory(item: ISeearchHistory): Promise<ISeearchHistory> {
  return api.post(`/search-histories`, item)
}
